import { InjectionToken } from '@angular/core';

import type { ReportCardAudience } from '../components/cards/jepto-card-query-status/card-query-status.util';

/**
 * Report canvas copy: Jepto editor vs public analytics viewer.
 * Defaults to editor when unset (Storybook, Jepto app).
 */
export const REPORT_CARD_AUDIENCE = new InjectionToken<ReportCardAudience>(
	'REPORT_CARD_AUDIENCE',
	{
		providedIn: 'root',
		factory: () => 'editor',
	}
);
